import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { LayoutWithCarousel } from '@/components/Layout';
import routes from '@/constants/routes';
import { useSignupStore } from '@/store';
import type { SignupState } from '@/types';
import CreateUsernameAndPasswordForm from '../components/CreateUsernameAndPasswordForm';
import type { CreateUsernameAndPasswordFormData } from '../../engine/create-username-and-password.model';
import '../../authentication-screens.styles.css';

const SignUpStepTwo = () => {
	const navigate = useNavigate();
	const { setUsernameAndPassword } = useSignupStore((state: SignupState) => state);

	const backButtonHandler = () => {
		navigate(routes['/sign-up']);
	};

	const handleSubmit = (data: CreateUsernameAndPasswordFormData) => {
		setUsernameAndPassword(data);
		navigate(routes['/sign-up/company-details']);
	};

	return (
		<LayoutWithCarousel>
			<Card className="sign-up-screen">
				<CreateUsernameAndPasswordForm
					isLoading={false}
					onBack={backButtonHandler}
					onSubmit={handleSubmit}
				/>
			</Card>
		</LayoutWithCarousel>
	);
};

export default SignUpStepTwo;
